module.exports = __webpack_public_path__ + "static/media/webdesign.c88557ea.jpg";